import {appUrl} from '@frontend/AppUrl'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на список сообщений в чате.
export function makeChatUrl(chatId: number): string {
    return NavigationService.makeUrl(
        appUrl().cabinet.chats.messages,
        null,
        {chat: String(chatId)}
    )
}
